import { MAINTENANCE_DISABLED } from '@shared/utils/constant'
import { MainPage } from '@/types'

export default defineNuxtRouteMiddleware((to) => {
  const $pinia = usePinia()
  const jsonStore = useSharedJsonStore($pinia)

  const isMaintenanceMode = !MAINTENANCE_DISABLED && jsonStore.isMaintenanceMode

  if (
    isMaintenanceMode &&
    ![MainPage.Maintenance, MainPage.ProposalDetails].includes(
      to.name as MainPage
    )
  ) {
    return navigateTo({ name: MainPage.Maintenance })
  }

  if (to.name === MainPage.Maintenance && !isMaintenanceMode) {
    return navigateTo({ name: MainPage.Index })
  }
})
